import userSignatoryHousesService from '@/repository/services/v2/user/signatoryHouses'
import userHousesService from '@/repository/services/v1/user/houses'
import type { UserHouse } from '@/repository/entities/user'

export const useUserHouses = () => {
  const { $apiClient } = useNuxtApp()

  const userHousesState = useState<{
    properties: UserHouse[]
    signatoryProperties: UserHouse[]
  }>('state-user-houses', () => ({
    properties: [],
    signatoryProperties: [],
  }))

  const properties = computed(() => userHousesState.value.properties)
  const propertyIds = computed(() => properties.value.map((p) => Number(p.id)))
  const signatoryPropertyIds = computed(() =>
    userHousesState.value.signatoryProperties.map((p) => Number(p.id)),
  )

  const fetchProperties = async () => {
    const properties = await userHousesService($apiClient).read()

    userHousesState.value.properties = properties?.data?.length
      ? properties.data
      : []
  }

  const fetchSignatoryProperties = async () => {
    const signatoryProperties =
      await userSignatoryHousesService($apiClient).read('?per=100')

    userHousesState.value.signatoryProperties = signatoryProperties?.data
      ?.length
      ? signatoryProperties.data
      : []
  }

  return {
    fetchProperties,
    fetchSignatoryProperties,
    properties,
    propertyIds,
    signatoryPropertyIds,
  }
}
